export enum MeasuringUnitEnum {
  POUND = 'Libra (Ib)',
  UNIT = 'Unidad (piece)',
  MILLILITER = 'Mililitro (ml)',
  BUNCH = 'Mazo',
  BAG = 'Bolsa',
  GRAM = 'Gramo (g)',
  OUNCES = 'Onzas (oz)',
  KILOGRAM = 'Kilogramo (kg)',
  LITER = 'Litro (l)',
  GALLON = 'Galón (gal)',
  ROLLS = 'Rollos',
  INCHES = 'Pulgadas (in)',
  BUCKET = 'Balde',
  METER = 'Metro (m)',
  FOOT = 'Pie (ft)',
  BIDON = 'Bidon',
  CARGA = 'Carga',
  QUINTAL = 'Quintal',
  RACIMO = 'Racimo',
}

export const MeasuringUnitOptions = [
  { label: 'pound', value: MeasuringUnitEnum.POUND },
  { label: 'unit', value: MeasuringUnitEnum.UNIT },
  { label: 'milliliter', value: MeasuringUnitEnum.MILLILITER },
  { label: 'bunch', value: MeasuringUnitEnum.BUNCH },
  { label: 'bag', value: MeasuringUnitEnum.BAG },
  { label: 'gram', value: MeasuringUnitEnum.GRAM },
  { label: 'ounces', value: MeasuringUnitEnum.OUNCES },
  { label: 'kilogram', value: MeasuringUnitEnum.KILOGRAM },
  { label: 'liter', value: MeasuringUnitEnum.LITER },
  { label: 'gallon', value: MeasuringUnitEnum.GALLON },
  { label: 'rolls', value: MeasuringUnitEnum.ROLLS },
  { label: 'inches', value: MeasuringUnitEnum.INCHES },
  { label: 'bucket', value: MeasuringUnitEnum.BUCKET },
  { label: 'meter', value: MeasuringUnitEnum.METER },
  { label: 'foot', value: MeasuringUnitEnum.FOOT },
  { label: 'bidon', value: MeasuringUnitEnum.BIDON },
  { label: 'carga', value: MeasuringUnitEnum.CARGA },
  { label: 'quintal', value: MeasuringUnitEnum.QUINTAL },
  { label: 'racimo', value: MeasuringUnitEnum.RACIMO },
];

export const getUnitDisplayName = (unit: string): string => {
  const option = MeasuringUnitOptions.find((opt) => opt.value === unit);
  return option ? option.label : unit;
};

export const getUnitDisplayNameWithTranslation = (
  unit: string,
  t: (key: string) => string
): string => {
  const option = MeasuringUnitOptions.find((opt) => opt.value === unit);
  return option ? t(option.label) : unit;
};

export enum prePackagedProductUnitEnum {
    GRAMS = 'GRAMS',
    POUNDS = 'POUNDS'
}
